import Cookie from 'js-cookie';
import md5 from 'md5';
var V = 'V';
// Javascript version of PHP uniqid function which is used to
// create the V cookie on chegg.com
var uniqid = function uniqid() {
  var dateMicroseconds = Date.now() / 1000;
  var dateString = dateMicroseconds.toString(16).split('.').join('');
  while (dateString.length < 14) {
    dateString += '0';
  }
  var randomNumber = Math.random() * 1000;
  var randomString = randomNumber.toString();
  return "".concat(md5(randomString)).concat(dateString, ".").concat(Math.floor(10000000 + Math.random() * 80000000));
};
var getVCookie = function getVCookie() {
  return Cookie.get(V);
};
export var getOrSetVCookie = function getOrSetVCookie(domain) {
  if (typeof window === 'undefined') return null;
  var vCookie = getVCookie();
  if (vCookie) return vCookie;
  var vHash = uniqid();
  var date = new Date();

  // V Cookie on chegg.com lasts 10 years
  var expires = new Date(date.getFullYear() + 10, date.getMonth(), date.getDay());
  Cookie.set(V, vHash, {
    domain: domain,
    expires: expires
  });
  return vHash;
};